import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'designSystem/components/Tooltip'
import React from 'react'

interface ChartTooltipProps {
  label: React.ReactNode
  children: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  style?: React.CSSProperties
}

/**
 * The chart's single tooltip surface. Everything hover-hinted on the chart —
 * toolbar buttons, the pen legend, the config panel — routes through here so it
 * shares one look: the design-system tooltip (white, rounded, arrow), the same
 * component the nav "Cases" tooltip uses. (The app-wide `TooltipWrapper` renders
 * `background1`, which is pure black in the dark theme — a different look.)
 *
 * The trigger is wrapped in an inline-flex span so the tooltip still fires when
 * the inner control is disabled and the wrapper adds no layout of its own.
 */
export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  label,
  children,
  side = 'top',
  style,
}) => {
  if (!label) return <>{children}</>
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span style={{ display: 'inline-flex', ...style }}>{children}</span>
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  )
}
